import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1b50c4c6&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=1b50c4c6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b50c4c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b50c4c6')) {
      api.createRecord('1b50c4c6', component.options)
    } else {
      api.reload('1b50c4c6', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=1b50c4c6&scoped=true", function () {
      api.rerender('1b50c4c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/clientForms/client-agreement/Index.vue"
export default component.exports